import { render, staticRenderFns } from "./Claimed.vue?vue&type=template&id=6552dfcc&scoped=true"
import script from "./Claimed.vue?vue&type=script&lang=js"
export * from "./Claimed.vue?vue&type=script&lang=js"
import style0 from "./Claimed.vue?vue&type=style&index=0&id=6552dfcc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6552dfcc",
  null
  
)

export default component.exports